export default __webpack_public_path__ + "static/media/VerifyPassPc.ff34ec7a.svg";